export default {
  name: 'Название',
  fullName: 'Полное название',
  type: 'Тип',
  tags: 'Тэги',
  filter: 'Фильтр',
  filters: 'Фильтры',
  form: 'Форма',
  more: 'Еще',
  construction: 'Объект',
  constructions: 'Объекты',
  contacts: 'Контакты',
  loading: 'Загрузка...',
  map: 'Карта',
  profile: 'Профиль',
  at: 'в',
  team: 'Команда',
  department: 'Отдел',
  dpp: 'ДПП',
  branch: 'Филиал',
  role: 'Роль',
  example: 'Пример',
  contact: 'Контакт',
  start: 'Начало',
  end: 'Конец',
  review: 'Обзор',
  photo: 'Фото',
  documents: 'Документы',
  generalContractor: 'Генподрядчик',
  distributionChannel: 'Канал сбыта',
  contract: 'Договор',
  contracts: 'Договоры',
  contractNumber: 'Номер договора',
  contractor: 'Подрядчик',
  contractors: 'Подрядчики',
  stages: 'Этапы',
  photoGallery: 'Фотогалерея',
  uploadPhoto: 'Загрузить фото',
  uploadDocuments: 'Загрузить документы',
  all: 'Все',
  selected: 'Выбранные',
  salesOrg: 'Сбытовая',
  materialGroup: 'Товарная группа',
  matgroup: 'ТГ',
  status: 'Статус',
  help: 'Справка',
  forExample: 'Например',
  employee: 'Сотрудник',
  scoringClient: 'Скоринг',
  comment: 'Комментарий',
  attention: 'Внимание',
  fileType: 'Тип файла',
  description: 'Описание',
  characteristics: 'Характеристики',
  stocks: 'Остатки',
  calculator: 'Калькулятор',
  available: 'Доступно',
  availability: 'Доступность',
  changeView: 'Изменить вид',
  numberPhone: 'Номер телефона',
  neverHave: 'Не было',
  phones: 'Телефоны',
  roles: 'Роли',
  sendSms: 'Написать смс',
  awaitForInvoice: 'Ждут отгрузки',
  orderNumber: 'Номер заказа',
  data: 'Данные',
};
